export default {
  attachments: [],
  loading: false
}
